import React, { useEffect, useRef } from 'react';
import { useToast } from 'hooks';
import { WppToastContainer } from '@wppopen/components-library-react';
import { useDispatch, useSelector } from 'react-redux';
import { resetNotification, serviceDataSlice } from 'Redux/serviceSlice';

export const Notifications = () => {
    const dispatch = useDispatch();
    const { type, header, message, duration } = useSelector(serviceDataSlice);
    const childRef = useRef(null);
    const { showToast } = useToast();

    useEffect(() => {
        if (type || header || message) {
            showToast({
                message,
                type,
                header,
                duration: duration || 5000,
                maxMessageLines: 3,
            });
            setTimeout(() => {
                dispatch(resetNotification());
            }, duration);
        }
    }, [type, header, message, duration, showToast, dispatch]);

    return <WppToastContainer maxToastsToDisplay={5} ref={childRef} />;
};
